module.exports = __webpack_public_path__ + "img/purple1.959e9df6.svg";